import React, {useEffect} from "react";
import Heading from "../../../components/Heading";
import Text from "../../../components/Text";
import IconButton from "../../../components/IconButton";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import FontCard from "./FontCard";
import {Font} from "../../../types/Font";
import Loader from "../../../components/Loader";
import {useGlobalContext} from "../../../contexts/globalContext";
import NewFontModalContent from "./NewFontModalContent";
import EditFontModalContent from "./EditFontModalContent";
import CreateCard from "./CreateCard";
import cx from 'classnames';
import styles from './FontSettings.module.css'
import {useTranslation} from "react-i18next";
import DeleteFontModalContent from "./DeleteFontModalContent";
import {useFetchData} from "../../../hooks/useFetchData";

const FontSettings: React.FC<{changeSettingsTab: (tab: string|null) => void}> = ({changeSettingsTab}) => {
    const {t} = useTranslation('settings');
    const {data: fonts, isLoading, fetch} = useFetchData<Font>('fonts')
    const {showModal, showToast} = useGlobalContext()

    const openCreateModal = () => {
        const content: JSX.Element = <NewFontModalContent fonts={fonts} onSubmit={() => fetch()}/>
        showModal({heading: t('fonts.create_modal.heading'), content: content, fullscreen: false})
    }

    const openEditModal = (font: Font) => {
        const content: JSX.Element = <EditFontModalContent font={font} fonts={fonts} onSubmit={() => fetch()}/>
        showModal({heading: t('fonts.edit_modal.heading'), content: content, fullscreen: false})
    }

    const openDeleteModal = (font: Font) => {
        const content: JSX.Element = <DeleteFontModalContent font={font} onSubmit={() => fetch()}/>
        if (fonts.length > 1) {
            showModal({
                heading: t('fonts.delete_modal.heading'),
                content: content,
                fullscreen: false
            })
        } else {
            showToast('top-right', 'error', 'Es ist mindestens eine Schriftart erforderlich')
        }

    }

    useEffect(() => {
        fetch()
    }, [fetch])

    return (
        <>
            <Heading level={3} classes={'my-4'}>{t('fonts.heading')}</Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => changeSettingsTab(null)}
            >
                {t('common.backToOverview')}
            </IconButton>
            <Text classes={'mt-3'}>
                {t('fonts.description')}
            </Text>
            <Heading level={4} classes={'my-4'}>{t('fonts.sub_heading')}</Heading>
            {!isLoading &&
                <div className={cx(styles['font-list'])}>
                    <CreateCard openCreateModal={openCreateModal} text={t('fonts.add_font')}/>
                    {fonts.sort((a,b) => {
                        if (a.name < b.name) return -1
                        else return 1
                    }).map((font: Font) => { return (
                        <FontCard
                            key={font.id}
                            {...font}
                            openEditModal={() => openEditModal(font)}
                            openDeleteModal={() => openDeleteModal(font)}
                        />
                    )})}
                </div>
            }
            {isLoading &&
                <div className={cx(styles['loading-wrapper'])}>
                    <Loader isLoading={isLoading} size={'m'}/>
                </div>
            }
        </>
    )
}



export default FontSettings
